import * as React from 'react'
import { FC, useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { styles } from './hooks/useStyles'
import Button from '@mui/material/Button'
import { DisqualifyReason } from './DisqualifyReason'
import {
  addEditFunnelReason,
  selectAllEditFunnelReasons,
  aggregateReasonsBySectionId,
} from '@user/store/salesFunnel/editSlice'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

const useReasonsBySectionId = (sectionId: string) => {
  const reasons = useSelector(selectAllEditFunnelReasons)

  const filteredReasons = useMemo(() => {
    return aggregateReasonsBySectionId(reasons, sectionId).map((x) => x.id)
  }, [sectionId, reasons])

  return filteredReasons
}

interface Props {
  sectionId: string
}

export const DisqualifyReasonList: FC<Props> = (props) => {
  const { sectionId } = props

  const reasons = useReasonsBySectionId(sectionId)

  const dispatch = useAppDispatch()

  const addClick = useCallback(() => {
    dispatch(addEditFunnelReason(sectionId))
  }, [dispatch, sectionId])

  const tidalThemeActive = useTidalThemeActive()
  return (
    <>
      {reasons && (
        <Box
          sx={{
            ...styles.subSection,
            marginLeft: tidalThemeActive ? 8.7 : 7.8,
          }}
          //marginLeft={tidalThemeActive ? 8.7 : 7.8}
        >
          <Box sx={styles.sectionHeader}>
            <span style={styles.sectionLabel}>Customize Reasons</span>
            <Button
              color="primary"
              variant="text"
              sx={styles.smallButton}
              onClick={addClick}
            >
              + Add New
            </Button>
          </Box>
          {reasons.map((reason, index) => (
            <DisqualifyReason key={reason} id={reason} index={index} />
          ))}
        </Box>
      )}
    </>
  )
}
